import { useMemo } from 'react';
import { isSystemVariable, normalizeVariableLabel, resolveSystemVariable } from '../TemplateVariables.utils';
export function useVariableResolution(variablesToResolve, context, templateVariableValues, businessDefaults) {
    return useMemo(()=>{
        const resolved = {};
        const defaultsByLabel = new Map();
        for (const d of businessDefaults){
            const key = normalizeVariableLabel(d.label.trim());
            if (!key) continue;
            if (!defaultsByLabel.has(key)) {
                defaultsByLabel.set(key, d.defaultValue);
            }
        }
        for (const label of variablesToResolve){
            const normalizedLabel = normalizeVariableLabel(label);
            if (isSystemVariable(label)) {
                resolved[normalizedLabel] = resolveSystemVariable(label, context);
            } else {
                const proposalValue = templateVariableValues[normalizedLabel];
                if (proposalValue !== undefined && proposalValue !== '') {
                    resolved[normalizedLabel] = proposalValue;
                } else {
                    const businessDefault = defaultsByLabel.get(normalizedLabel);
                    resolved[normalizedLabel] = businessDefault !== '' ? businessDefault : undefined;
                }
            }
        }
        return resolved;
    }, [
        variablesToResolve,
        context,
        templateVariableValues,
        businessDefaults
    ]);
}
